import { SectionWrapper } from "../../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary, Grid } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../../ui-components/pageLayout/TableSettingsComponents";
import { CustomFormField, FormField } from "../../../../../Form/FormField";
import CheckboxComponent from "../../../../ui-components/fields/CheckboxComponent";
import { OfferingType } from "@nendaTypes/NendaTypes";
import React from "react";

const FeatureSetBasicInformationAccordion: React.FC = () => {
  return (
    <SectionWrapper>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Basic information
        </AccordionSummary>
        <AssetAccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormField
                name="name"
                label="name"
                placeholder="Feature Set name used in the Admin Portal..."
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                name="description"
                label="description"
                placeholder="Feature Set description used in the Admin Portal..."
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                name="externalRef"
                label="external ref"
                placeholder="Feature Set external ref..."
              />
            </Grid>
            <Grid item xs={6}>
              <CustomFormField
                name="enabled"
                label="enabled"
                placeholder="Feature Set enabled..."
                component={CheckboxComponent}
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                name={`type`}
                label="Type"
                select
                options={[
                  { label: "none", value: "" },
                  ...Object.values(OfferingType).map((val) => ({
                    label: val,
                    value: val,
                  })),
                ]}
                placeholder="Type"
              />
            </Grid>
          </Grid>
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default FeatureSetBasicInformationAccordion;
